import { withHost } from 'utils';

export const Api = {
  FetchToken: withHost('/tokens'),
  FetchUserToken: withHost('/tokens/user'),
  Signup: withHost('/users'),
  VerifyEmail: (email, hash) => {
    const queryParams = new URLSearchParams();
    queryParams.append('email', email);
    queryParams.append('v', hash);

    return withHost(`/users/verify?${queryParams}`);
  },
  PublishProfile: withHost('/users/fields'),
  SendVerificationEmail: withHost('/users/verify/send'),
};
